module.exports = __webpack_public_path__ + "img/IMG_1231_L_Black_MockedUp.52035faf.jpg";